import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "who are yoU",
    description: "A short note on the sea, the tides, and the patient rhythm of leaving and coming home.",
    url: getOrigin()
}